import { createSlice } from '@reduxjs/toolkit';


interface IProps  {
    modalIsOpen: boolean;
}

export const GeoTagModalStateSlice = createSlice({
    name: 'geoTagModal',
    initialState: {
        modalIsOpen: false,
    },
    reducers: {
        toggle: (state, action) => {
            state.modalIsOpen = action.payload;
        }
    }
});

export default GeoTagModalStateSlice
export const GeoTagModalStateAction = GeoTagModalStateSlice.actions
export const GeoTagModalSelector = (store: { geoTagModal: IProps }): IProps => store.geoTagModal;
import { createSlice } from '@reduxjs/toolkit';


interface IProps  {
    modalIsOpen: boolean;
}

export const GeoTagModalStateSlice = createSlice({
    name: 'geoTagModal',
    initialState: {
        modalIsOpen: false,
    },
    reducers: {
        toggle: (state, action) => {
            state.modalIsOpen = action.payload;
        }
    }
});

export default GeoTagModalStateSlice
export const GeoTagModalStateAction = GeoTagModalStateSlice.actions
export const GeoTagModalSelector = (store: { geoTagModal: IProps }): IProps => store.geoTagModal;
